import formatFileSize from './utils'

const messages = {
  _default: () => `value is not valid.`,
  after: (field, [target, inclusion]) =>
    `must be after ${inclusion ? 'or equal to ' : ''}${target}.`,
  alpha_dash: () =>
    `field may contain alpha-numeric characters as well as dashes and underscores.`,
  alpha_num: () =>
    `field may only contain alpha-numeric characters.`,
  alpha_spaces: () =>
    `field may only contain alphabetic characters as well as spaces.`,
  alpha: () => `field may only contain alphabetic characters.`,
  before: (field, [target, inclusion]) =>
    `must be before ${inclusion ? 'or equal to ' : ''}${target}.`,
  between: (field, [min, max]) =>
    `field must be between ${min} and ${max}.`,
  confirmed: () => `confirmation does not match.`,
  credit_card: () => `field is invalid.`,
  date_between: (field, [min, max]) =>
    `must be between ${min} and ${max}.`,
  date_format: (field, [format]) =>
    `must be in the format ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `field must be numeric and may contain ${
      !decimals || decimals === '*' ? '' : decimals
    } decimal points.`,
  digits: (field, [length]) =>
    `field must be numeric and exactly contain ${length} digits.`,
  dimensions: (field, [width, height]) =>
    `field must be ${width} pixels by ${height} pixels.`,
  email: () => `field must be a valid email.`,
  ext: () => `field must be a valid file.`,
  image: () => `field must be an image.`,
  in: () => `field must be a valid value.`,
  integer: () => `field must be an integer.`,
  ip: () => `field must be a valid ip address.`,
  length: (field, [length, max]) => {
    if (max) {
      return `length must be between ${length} and ${max}.`
    }

    return `length must be ${length}.`
  },
  max: (field, [length]) =>
    `field may not be greater than ${length} characters.`,
  max_value: (field, [max]) => `field must be ${max} or less.`,
  mimes: () => `field must have a valid file type.`,
  min: (field, [length]) =>
    `field must be at least ${length} characters.`,
  min_value: (field, [min]) => `field must be ${min} or more.`,
  not_in: () => `field must be a valid value.`,
  numeric: () => `field may only contain numeric characters.`,
  regex: () => `field format is invalid.`,
  required: () => `field is required.`,
  size: (field, [size]) =>
    `size must be less than ${formatFileSize(size)}.`,
  url: () => `field is not a valid URL.`,
  fullName: () => 'is not valid (name, first name and max 120. characters)',
  emailInput: () => 'field must be a valid email.',
  fullNamePerCountry: () => 'is not valid (name, first name and max 18. characters)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'en',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/en.js